import useEventListener from "@use-it/event-listener";
import { Button } from "antd";
import moment from "moment";
import React, { useEffect, useReducer, useRef } from "react";
import { addTestResult } from "../../api/addTestResult";
import { getStudentData } from "../../helper/localStorage";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { answeredQues } from "../../helper/testHelper";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import "./simpleReaction.scss";
const SPACE_KEYS = ["32", " "];

const initialValue = {
  userTapMsg: false,
  userTapScreen: false,
  screenShown: false,
  startTime: null,
  totalTimeTaken: 10000, //this is the max time a user can take
  tapBefore: false,
  tapAfter: false,
  isNext: false,
  quesNo: "",
  actualStartTime: "", //test start from the beginning
};

const reducer = (state, action) => {
  switch (action.type) {
    case "TEST_STARTED": {
      return { ...state, actualStartTime: moment() };
    }
    case "MSG_CLICK": {
      return { ...state, userTapMsg: true };
    }
    case "SCREEN_SHOW":
      return { ...state, screenShown: true };

    case "START_TIME":
      return { ...state, startTime: action.payload };

    case "USER_TAP":
      const totalTimeTaken = moment().diff(state.startTime);
      console.log("totalTimeTaken(startTime)", totalTimeTaken);
      return { ...state, userTapScreen: true, totalTimeTaken };

    case "TAP_BEFORE":
      return { ...state, tapBefore: true };

    case "TAP_AFTER":
      return { ...state, tapAfter: true };

    case "MOVE_TO_NEXT":
      return { ...state, isNext: true };

    case "RESET":
      console.log("testing inside reset");
      return { ...initialValue };

    default:
      break;
  }
};

function SimpleReaction({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();

  const timerToClear30s = useRef(null);
  const timerToClear7s = useRef(null);
  const timerToClear6s = useRef(null);
  const screenShownTimer = useRef(null);
  const tapBtn = useRef(null);

  console.log(answerC.answers);

  const [SR, dispatchSR] = useReducer(reducer, initialValue);
  const {
    userTapScreen,
    userTapMsg,
    screenShown,
    totalTimeTaken,
    tapBefore,
    tapAfter,
    isNext,
    actualStartTime,
  } = SR;

  useEffect(() => {
    dispatchSR({ type: "RESET" });
    dispatchSR({ type: "TEST_STARTED" });
    clearTimeout(timerToClear30s.current);
    clearTimeout(timerToClear6s.current);
    clearTimeout(timerToClear7s.current);
    timerToClear30s.current = setTimeout(() => {
      console.log("settime out condition runs with 30s timeout");
      dispatchSR({ type: "MSG_CLICK" });
      handleMsgClick();
    }, 10000);
    return () => {
      clearTimeout(timerToClear30s.current);
    };
  }, []);

  useEffect(() => {
    if (isNext) {
      console.log("totalTimeTaken on before next", totalTimeTaken);
      handleNext();
    }
  }, [isNext]);

  // just after screen shown
  useEffect(() => {
    if (!tapBefore && screenShown) {
      dispatchSR({ type: "START_TIME", payload: moment() });
      timerToClear6s.current = setTimeout(() => {
        console.log("settime out condition 6s and tap after");
        dispatchSR({ type: "TAP_AFTER" });
      }, 6000);
      timerToClear7s.current = setTimeout(() => {
        console.log("settime out condition 7s and forward");
        dispatchSR({ type: "MOVE_TO_NEXT" });
      }, 7000);
      return () => {
        clearTimeout(timerToClear6s.current);
        clearTimeout(timerToClear7s.current);
      };
    }
  }, [screenShown]);

  // for performance

  useEffect(() => {
    if (totalTimeTaken !== 10000) {
      setTimeout(() => {
        console.log("setTimeout out condition runs proper tap", totalTimeTaken);
        dispatchSR({ type: "MOVE_TO_NEXT" });
      }, 1500);
    } else if (tapBefore) {
      setTimeout(() => {
        console.log("setTimeout out condition runs early tap", totalTimeTaken);
        dispatchSR({ type: "MOVE_TO_NEXT" });
      }, 1500);
    } else if (tapAfter) {
      setTimeout(() => {
        console.log("setTimeout out condition runs late tap", totalTimeTaken);
        dispatchSR({ type: "MOVE_TO_NEXT" });
      }, 1500);
    }
  }, [totalTimeTaken, tapAfter, tapBefore]);

  const handleMsgClick = () => {
    const min = 3;
    const max = 7;
    let rand = Math.random() * (max - min) + min;
    rand = Math.floor(rand);
    screenShownTimer.current = setTimeout(() => {
      if (!tapBefore) {
        dispatchSR({ type: "SCREEN_SHOW" });
        dispatchSR({ type: "MSG_CLICK" });
      }
    }, rand * 1000);
  };

  const handleBoxClick = () => {
    if (!userTapMsg) {
      dispatchSR({ type: "MSG_CLICK" });
      handleMsgClick();
    }
    // early tap consider if user tap before appearing the blue screen
    if (userTapMsg && !screenShown) {
      clearTimeout(screenShownTimer.current);
      dispatchSR({ type: "TAP_BEFORE" });
    }
    if (userTapMsg && screenShown && !tapBefore && !tapAfter) {
      clearTimeout(timerToClear6s.current);
      dispatchSR({ type: "USER_TAP", payload: moment() });
    }
  };

  const handleNext = () => {
    const nextTest = questions[index + 1];
    const answer_flag =
      totalTimeTaken < 75
        ? "Anticipatory Tap"
        : tapBefore
        ? "Too Early"
        : tapAfter
        ? "Too Late"
        : "";
    const value = { totalTimeTaken, answer_flag };
    const timeSpend = moment().diff(actualStartTime);

    // FIXME
    if (index < questions.length - 1) {
      if (helperC.testType === "CALIBRATION") {
        dispatchAnswer({
          type: "ADD_ANSWER",
          payload: answeredQues(
            "simple_reactionCal",
            value,
            question,
            timeSpend
          ),
        });
      } else {
        dispatchAnswer({
          type: "ADD_ANSWER",
          payload: answeredQues("simple_reaction", value, question, timeSpend),
        });
      }

      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest.id,
      });
    } else {
      // this condition run at end(submit) of the question
      let answerRes = [
        ...answerC.answers,
        answeredQues("simple_reaction", value, question, timeSpend),
      ];

      const grade_id = JSON.parse(localStorage.getItem("gradeId"));
      const { login_id } = getStudentData();
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions,
        true //is reaction test
      );

      console.log("actualScore", player_score);

      answerRes = answerRes.map((answer) => {
        return { ...answer, answer: "" };
      });

      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes,
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      // api hitting to send data to server
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);

      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: answeredQues("simple_reaction", value, question),
      });

      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  };

  const handleEarlyTap = () => {
    setTimeout(() => {
      console.log("setTimeout out condition runs early tap", totalTimeTaken);
      dispatchSR({ type: "MOVE_TO_NEXT" });
    }, 1500);

    return <h3>Oops! You Tapped the screen too early</h3>;
  };

  const handleCorrectTap = () => {
    console.log("testing inside handleCorrectTap");
    setTimeout(() => {
      console.log("setTimeout out condition runs proper tap", totalTimeTaken);
      dispatchSR({ type: "MOVE_TO_NEXT" });
    }, 1500);
    return <h3>Reaction time {totalTimeTaken}ms</h3>;
  };

  const handleLateTap = () => {
    setTimeout(() => {
      console.log("setTimeout out condition runs late tap", totalTimeTaken);
      dispatchSR({ type: "MOVE_TO_NEXT" });
    }, 1500);
    return <h3>Oops! You Tapped the screen too late</h3>;
  };

  const handleKeyPress = (e) => {
    console.log(e.key);
    if (e.key === 32 || e.key === "32") {
      return totalTimeTaken === 10000 ? handleBoxClick() : undefined;
    }
  };

  function handler({ key }) {
    if (SPACE_KEYS.includes(String(key))) {
      console.log();
      tapBtn.current.click();
    }
  }
  useEventListener("keyup", handler);

  return (
    <div className="simple-reaction">
      <Button
        ref={tapBtn}
        className={`touchable-screen ${userTapMsg && "msgDisable"} ${
          screenShown && "showScreen"
        }`}
        onKeyPress={(e) => handleKeyPress(e)}
        onClick={
          () => (totalTimeTaken === 10000 ? handleBoxClick() : undefined) // prevent double tap while capturing response time
        }
      >
        {!userTapMsg ? (
          <span className="simple-instr">
            Touch here or Press spacebar to start.
            <br />
            Touch this area again when it turns blue
          </span>
        ) : (
          <span className="simple-instr">Make sure you tap quickly</span>
        )}
      </Button>
      <h4>Tap in the above Box or Press Spacebar</h4>
      <div
        className={
          userTapScreen || tapBefore || tapAfter
            ? "message-blk active"
            : "message-blk"
        }
      >
        {/* {totalTimeTaken !== 10000 && handleCorrectTap()}
        {tapBefore && handleEarlyTap()}
        {tapAfter && handleLateTap()} */}
        {/* for performance */}
        {totalTimeTaken !== 10000 && <h3>Reaction time {totalTimeTaken}ms</h3>}
        {tapBefore && <h3>Oops! You Tapped the screen too early</h3>}
        {tapAfter && <h3>Oops! You Tapped the screen too late</h3>}
      </div>
    </div>
  );
}

export default React.memo(SimpleReaction);
